/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: process.env.REACT_APP_B2C_SIGNUPSIGNINPOLICY ? process.env.REACT_APP_B2C_SIGNUPSIGNINPOLICY.toString() : ""
        //forgotPassword: 'B2C_1A_ROLESUSI',
        //editProfile: 'B2C_1A_ROLESUSI',
    },
    authorities: {
        signUpSignIn: {
            authority: process.env.REACT_APP_B2C_SIGNUPSIGNINAUTHORITY ? process.env.REACT_APP_B2C_SIGNUPSIGNINAUTHORITY.toString() : "",
        }
        //forgotPassword: {
        //    authority: 'https://CommScopeTstB2C.b2clogin.com/CommScopeTstB2C.onmicrosoft.com/B2C_1A_ROLESUSI',
        //},
        //editProfile: {
        //    authority: 'https://CommScopeTstB2C.b2clogin.com/CommScopeTstB2C.onmicrosoft.com/B2C_1A_ROLESUSI',
        //},
    },
    authorityDomain: process.env.REACT_APP_B2C_AUTHORITYDOMAIN ? process.env.REACT_APP_B2C_AUTHORITYDOMAIN.toString() : "",
};


/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_B2C_CLIENTID ? process.env.REACT_APP_B2C_CLIENTID.toString() : "", // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorityDomain, // Choose SUSI as your default authority.
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: process.env.REACT_APP_B2C_REDIRECT_URI ? process.env.REACT_APP_B2C_REDIRECT_URI.toString() : "", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
        responseType: 'token', // "code" or "id_token code". Use "code" for Implicit flow and "id_token code" for Hybrid flow.
        metadata: process.env.REACT_APP_B2C_METADATA ? process.env.REACT_APP_B2C_METADATA.toString() : "",
    },
    cache: {
        cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    vistanceUniversityAPIList: {
        endpoint: process.env.REACT_APP_B2C_APIENDPOINT ? process.env.REACT_APP_B2C_APIENDPOINT.toString() : "",
        scopes: {
            read: [process.env.REACT_APP_B2C_READSCOPE ? process.env.REACT_APP_B2C_READSCOPE.toString() : ""],
            write: [process.env.REACT_APP_B2C_WRITESCOPE ? process.env.REACT_APP_B2C_WRITESCOPE.toString() : ""],
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["openid", "offline_access", ...protectedResources.vistanceUniversityAPIList.scopes.read, ...protectedResources.vistanceUniversityAPIList.scopes.write],
    domain_hint: process.env.REACT_APP_B2C_DOMAINHINT ? process.env.REACT_APP_B2C_DOMAINHINT.toString() : ""
};